const isMac = () => navigator?.userAgent?.includes('Mac');
const ARROW_DOWN = 'ArrowDown';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';
const PAGE_DOWN = 'PageDown';
const PAGE_UP = 'PageUp';
const ENTER = 'Enter';
const SPACE = ' ';
const HOME = 'Home';
const END = 'End';
const MINUS = '-';
const ESCAPE = 'Escape';
const TAB = 'Tab';
const BACKSPACE = 'Backspace';
const DELETE = 'Delete';
const isEscapeKeyEvent = e => !!(e?.key === ESCAPE);
const isKeyboardClick = e => e.key === ENTER || e.key === SPACE;
const isRedoShortcut = e => {
  if (isMac()) {
    return e.key === 'z' && e.metaKey && e.shiftKey;
  }
  return e.key === 'y' && e.ctrlKey;
};
const isUndoShortcut = e => {
  if (isMac()) {
    return e.key === 'z' && e.metaKey;
  }
  return e.key === 'z' && e.ctrlKey;
};

export { ARROW_DOWN, ARROW_LEFT, ARROW_RIGHT, ARROW_UP, BACKSPACE, DELETE, END, ENTER, ESCAPE, HOME, MINUS, PAGE_DOWN, PAGE_UP, SPACE, TAB, isEscapeKeyEvent, isKeyboardClick, isRedoShortcut, isUndoShortcut };
